import React from "react";
import HeroSection from "./../../components/HeroSection";
import StatsSection from "./../../components/StatsSection";
import FeaturesSection from "./../../components/FeaturesSection";
import CtaSection from "./../../components/CtaSection";
import TestimonialsSection from "./../../components/TestimonialsSection";
import { useRouter } from "./../../util/router.js";
import "./styles.scss";
import trashImage from "../../images/trash.svg";

function HomePage(props) {
  const router = useRouter();

  return (
    <React.Fragment>
      <HeroSection
        color="white"
        size="medium"
        title={
          <span>
            Be kind to the environment. <br />
            Be less wasteful.
          </span>
        }
        subtitle="Our day to day choices make a big impact on the amount of waste we produce. Take us through your typical day and we’ll see what you can do to be less wasteful."
        buttonText="Get started"
        image={trashImage}
        buttonOnClick={() => {
          router.push("/story-quiz");
        }}
      />
      <StatsSection
        color="white"
        size="medium"
        items={[
          {
            title:
              "Household Consumption expenditure increase between 1994 and 2008",
            stat: "78%"
          },
          {
            title: "Consumption of packaging per person in 2007",
            stat: "164kg"
          },
          {
            title: "Amount recycled in 2008",
            stat: "60%"
          }
        ]}
      />
      <FeaturesSection
        color="white"
        size="medium"
        title="The journey to zero-waste"
        subtitle="It's not an easy journey. There will be challenges along the way, but we can be your guide."
      />
      <CtaSection
        color="white"
        size="medium"
        title="What can you do every day to reduce your waste?"
        buttonText="Get started"
        buttonOnClick={() => {
          router.push("/story-quiz");
        }}
      />
      <TestimonialsSection
        color="light"
        size="medium"
        title="Join others just like you!"
        subtitle=""
      />
    </React.Fragment>
  );
}

export default HomePage;
